export enum FireRiskEnum {
	NONE = 'NAO_ESPECIFICADO',
	NULL = 'NULO',
	SMALL = 'PEQUENO',
	MEDIUM = 'MEDIO',
	HIGH = 'ALTO',
	HIGHEST = 'MUITO_ALTO',
}
